"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function DebugDirective(config, book, uploads, textResolver, testFeatures, $interpolate) {
    'ngInject';
    return {
        restrict: 'AE',
        templateUrl: config.params.base + "templates/helpers/debug.html",
        controller: /** @class */ (function () {
            function DebugController($scope) {
                var _this = this;
                this.$scope = $scope;
                this.pinned = false;
                this.uploads = uploads.getUploads();
                this.book = book;
                this.meta = {
                    id: config.configJson.id,
                    version: config.configJson.version,
                    name: this.interpolate(config.configJson.name)
                };
                this.$scope.$watch(function () { return book; }, function () {
                    _this.meta.name = _this.interpolate(config.configJson.name);
                }, true);
            }
            DebugController.prototype.pin = function (pin) {
                this.pinned = pin;
            };
            DebugController.prototype.interpolate = function (expression) {
                var result = $interpolate(expression)(Object.assign({}, this.book, {
                    resolve: textResolver.resolve.bind(textResolver),
                    hasFeature: testFeatures.hasFeature.bind(testFeatures)
                }));
                return result;
            };
            return DebugController;
        }()),
        controllerAs: 'debugCtrl'
    };
}
exports.DebugDirective = DebugDirective;
exports.default = angular.module('pb.debug', [])
    .directive('pbDebug', DebugDirective);
